/**
 * Compute an integrity hash for an acta payload.
 *
 * Uses `crypto.subtle.digest('SHA-256')` when available (modern browsers),
 * falls back to FNV-1a 32-bit for non-browser environments.
 *
 * @param {unknown} payload - Serializable object to hash.
 * @returns {Promise<string>} Hex digest.
 */
export async function computeActaHash(payload) {
  const raw = JSON.stringify(payload)
  if (typeof window !== 'undefined' && window.crypto?.subtle && window.TextEncoder) {
    const bytes = new TextEncoder().encode(raw)
    const digest = await window.crypto.subtle.digest('SHA-256', bytes)
    return Array.from(new Uint8Array(digest))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
  }
  let h = 2166136261
  for (let i = 0; i < raw.length; i += 1) {
    h ^= raw.charCodeAt(i)
    h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24)
  }
  return `fallback-${(h >>> 0).toString(16).padStart(8, '0')}`
}
